export class TextImageContainer {
  text = '';
  fileIds = [];

  constructor(obj = {}) {
    this.text = obj?.text || '';
    this.fileIds = obj?.fileIds || [];
  }
}
